import { toDropdownOptions } from '@/helpers'
import { getMinerModelFamilies } from '@/services/core.service'
import { useQuery } from '@tanstack/vue-query'
import type { OptionType } from 'element-plus/es/components/select-v2/src/select.types.mjs'
import { ref, watchEffect } from 'vue'

export const useMinerModelFamilies = () => {
  const { data, isPending, isError, error } = useQuery({
    queryFn: getMinerModelFamilies,
    queryKey: ['miner-model-families'],
  })

  const minerModelFamilyOptions = ref<OptionType[]>()

  watchEffect(() => {
    minerModelFamilyOptions.value = data.value ? toDropdownOptions(data.value) : []
  })

  return { data, isPending, isError, error, minerModelFamilyOptions }
}
